import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Always_getInstancecs10mhg5aot2 as Always_getInstance } from './Condition.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../serialization/DataClassPathSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Companion_getInstancetl9eamf8zl9j as Companion_getInstance } from './Aggregate.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupCountQuery', null, 2);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('groupBy', false);
        this.f3l_1 = tmp0_serialDesc;
      }
      s2j(typeSerial0) {
        return $serializer().i3z(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.s2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static j3z() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupCountQuery', $this, 2);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('groupBy', false);
        $this.g3z_1 = tmp0_serialDesc;
        return $this;
      }
      k3z(encoder, value) {
        var tmp0_desc = this.g3z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.l3z_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.h3z_1), value.l3z_1);
        }
        tmp1_output.c15(tmp0_desc, 1, new (DataClassPathSerializer())(this.h3z_1), value.m3z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k3z(encoder, value instanceof GroupCountQuery() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g3z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.h3z_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (DataClassPathSerializer())(this.h3z_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.h3z_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (DataClassPathSerializer())(this.h3z_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return GroupCountQuery().n3z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.g3z_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.h3z_1), new (DataClassPathSerializer())(this.h3z_1)];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.h3z_1];
      }
      static i3z(typeSerial0) {
        var $this = this.j3z();
        $this.h3z_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var GroupCountQueryClass;
function GroupCountQuery() {
  if (GroupCountQueryClass === VOID) {
    class $ {
      toString() {
        return 'GroupCountQuery(condition=' + toString(this.l3z_1) + ', groupBy=' + this.m3z_1.toString() + ')';
      }
      hashCode() {
        var result = this.l3z_1.hashCode();
        result = imul(result, 31) + this.m3z_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupCountQuery()))
          return false;
        if (!this.l3z_1.equals(other.l3z_1))
          return false;
        if (!this.m3z_1.equals(other.m3z_1))
          return false;
        return true;
      }
      static n3z(seen0, condition, groupBy, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, Companion_getInstance_0().f3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.l3z_1 = Always_getInstance();
        else
          $this.l3z_1 = condition;
        $this.m3z_1 = groupBy;
        return $this;
      }
    }
    initMetadataForClass($, 'GroupCountQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    GroupCountQueryClass = $;
  }
  return GroupCountQueryClass;
}
function AggregateQuery$Companion$$childSerializers$_anonymous__mdtkin() {
  return Companion_getInstance().m2a();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g3l_1 = [lazy(tmp_0, AggregateQuery$Companion$$childSerializers$_anonymous__mdtkin), null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.AggregateQuery', null, 3);
        tmp0_serialDesc.c1b('aggregate', false);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('property', false);
        this.h3l_1 = tmp0_serialDesc;
      }
      s2j(typeSerial0) {
        return $serializer_0().q3z(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.s2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static r3z() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.AggregateQuery', $this, 3);
        tmp0_serialDesc.c1b('aggregate', false);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('property', false);
        $this.o3z_1 = tmp0_serialDesc;
        return $this;
      }
      s3z(encoder, value) {
        var tmp0_desc = this.o3z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().g3l_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t3z_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.u3z_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.p3z_1), value.u3z_1);
        }
        tmp1_output.c15(tmp0_desc, 2, new (DataClassPathSerializer())(this.p3z_1), value.v3z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s3z(encoder, value instanceof AggregateQuery() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.o3z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().g3l_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.p3z_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.p3z_1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.p3z_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.p3z_1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return AggregateQuery().w3z(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.o3z_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_1().g3l_1[0].f2(), new (ConditionSerializer())(this.p3z_1), new (DataClassPathSerializer())(this.p3z_1)];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.p3z_1];
      }
      static q3z(typeSerial0) {
        var $this = this.r3z();
        $this.p3z_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var AggregateQueryClass;
function AggregateQuery() {
  if (AggregateQueryClass === VOID) {
    class $ {
      constructor(aggregate, condition, property) {
        Companion_getInstance_1();
        condition = condition === VOID ? Always_getInstance() : condition;
        this.t3z_1 = aggregate;
        this.u3z_1 = condition;
        this.v3z_1 = property;
      }
      toString() {
        return 'AggregateQuery(aggregate=' + this.t3z_1.toString() + ', condition=' + toString(this.u3z_1) + ', property=' + this.v3z_1.toString() + ')';
      }
      hashCode() {
        var result = this.t3z_1.hashCode();
        result = imul(result, 31) + this.u3z_1.hashCode() | 0;
        result = imul(result, 31) + this.v3z_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AggregateQuery()))
          return false;
        if (!this.t3z_1.equals(other.t3z_1))
          return false;
        if (!this.u3z_1.equals(other.u3z_1))
          return false;
        if (!this.v3z_1.equals(other.v3z_1))
          return false;
        return true;
      }
      static w3z(seen0, aggregate, condition, property, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(5 === (5 & seen0))) {
          throwMissingFieldException(seen0, 5, Companion_getInstance_1().h3l_1);
        }
        var $this = createThis(this);
        $this.t3z_1 = aggregate;
        if (0 === (seen0 & 2))
          $this.u3z_1 = Always_getInstance();
        else
          $this.u3z_1 = condition;
        $this.v3z_1 = property;
        return $this;
      }
    }
    initMetadataForClass($, 'AggregateQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    AggregateQueryClass = $;
  }
  return AggregateQueryClass;
}
function GroupAggregateQuery$Companion$$childSerializers$_anonymous__px3v0i() {
  return Companion_getInstance().m2a();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i3l_1 = [lazy(tmp_0, GroupAggregateQuery$Companion$$childSerializers$_anonymous__px3v0i), null, null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupAggregateQuery', null, 4);
        tmp0_serialDesc.c1b('aggregate', false);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('groupBy', false);
        tmp0_serialDesc.c1b('property', false);
        this.j3l_1 = tmp0_serialDesc;
      }
      s2j(typeSerial0) {
        return $serializer_1().z3z(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.s2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      static a40() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupAggregateQuery', $this, 4);
        tmp0_serialDesc.c1b('aggregate', false);
        tmp0_serialDesc.c1b('condition', true);
        tmp0_serialDesc.c1b('groupBy', false);
        tmp0_serialDesc.c1b('property', false);
        $this.x3z_1 = tmp0_serialDesc;
        return $this;
      }
      b40(encoder, value) {
        var tmp0_desc = this.x3z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().i3l_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.c40_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.d40_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.y3z_1), value.d40_1);
        }
        tmp1_output.c15(tmp0_desc, 2, new (DataClassPathSerializer())(this.y3z_1), value.e40_1);
        tmp1_output.c15(tmp0_desc, 3, new (DataClassPathSerializer())(this.y3z_1), value.f40_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b40(encoder, value instanceof GroupAggregateQuery() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x3z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_2().i3l_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.y3z_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.y3z_1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, new (DataClassPathSerializer())(this.y3z_1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.y3z_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.y3z_1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, new (DataClassPathSerializer())(this.y3z_1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return GroupAggregateQuery().g40(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.x3z_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_2().i3l_1[0].f2(), new (ConditionSerializer())(this.y3z_1), new (DataClassPathSerializer())(this.y3z_1), new (DataClassPathSerializer())(this.y3z_1)];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.y3z_1];
      }
      static z3z(typeSerial0) {
        var $this = this.a40();
        $this.y3z_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var GroupAggregateQueryClass;
function GroupAggregateQuery() {
  if (GroupAggregateQueryClass === VOID) {
    class $ {
      toString() {
        return 'GroupAggregateQuery(aggregate=' + this.c40_1.toString() + ', condition=' + toString(this.d40_1) + ', groupBy=' + this.e40_1.toString() + ', property=' + this.f40_1.toString() + ')';
      }
      hashCode() {
        var result = this.c40_1.hashCode();
        result = imul(result, 31) + this.d40_1.hashCode() | 0;
        result = imul(result, 31) + this.e40_1.hashCode() | 0;
        result = imul(result, 31) + this.f40_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupAggregateQuery()))
          return false;
        if (!this.c40_1.equals(other.c40_1))
          return false;
        if (!this.d40_1.equals(other.d40_1))
          return false;
        if (!this.e40_1.equals(other.e40_1))
          return false;
        if (!this.f40_1.equals(other.f40_1))
          return false;
        return true;
      }
      static g40(seen0, aggregate, condition, groupBy, property, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(13 === (13 & seen0))) {
          throwMissingFieldException(seen0, 13, Companion_getInstance_2().j3l_1);
        }
        var $this = createThis(this);
        $this.c40_1 = aggregate;
        if (0 === (seen0 & 2))
          $this.d40_1 = Always_getInstance();
        else
          $this.d40_1 = condition;
        $this.e40_1 = groupBy;
        $this.f40_1 = property;
        return $this;
      }
    }
    initMetadataForClass($, 'GroupAggregateQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    GroupAggregateQueryClass = $;
  }
  return GroupAggregateQueryClass;
}
//region block: exports
export {
  AggregateQuery as AggregateQuery2zg9ab3akfubi,
  Companion_getInstance_1 as Companion_getInstance2me4dixbj0lj0,
  Companion_getInstance_2 as Companion_getInstance2r8wjyblz0idz,
  Companion_getInstance_0 as Companion_getInstance1khfkwo5dix9p,
};
//endregion

//# sourceMappingURL=GroupCountQuery.mjs.map
